import React, { useState, useEffect} from "react";
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Container, Row, Alert, Col, Button } from "react-bootstrap";
import Loader from "../../components/widgets/Loader.jsx";
import axios from '../../services/axios.js';
import ApkFiltersComponent from "../../components/apks/ApkFiltersComponent.jsx"
import ApksTableComponent from "../../components/apks/ApksTableComponent.jsx"
import PackageClientsComponent from "../../components/packages/PackageClientsComponent.jsx";
import useSearchWithParams from "../../hooks/useSearchWithParams";
import { useModal } from "../../hooks/useModal.jsx";
import { useParams, Link } from "react-router-dom";
import useBackButton from "../../hooks/useBackButton.jsx";
import AuthorizationChecker from "../../services/AuthorizationChecker.js";


const PackageDetailPage = () => {

    const {packageById , isFetchingOnePackage} = useStoreState(state => state.packages);
    const {fetchPackageById} = useStoreActions(actions => actions.packages);
    const [filteredApks, setFilteredApks] = useState([]);
    const [loaderApps, setLoaderApps] = useState(null);
    const [versionSimulated, setVersionSimulated] = useState(null);
    const { searchInput, search } = useSearchWithParams({ placeholder: 'Rechercher par mots-clés (version, nom, description)', delay: 400 });
    const { modalComponent, setModalShow, modalData, setModalData, setIsSending } = useModal();

    const { apiData: { ACTIONS } } = useStoreState(state => state.actionSlugs);
    const apkSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher("apks"));
    const packagesSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher("packages"));
    const { backButtonComponent } = useBackButton();

     const {uniqueId} = useParams();

    useEffect(() => {
       fetchPackageById(uniqueId).then((pkg) => {
            setFilteredApks(pkg.apks);
        })
    }, [uniqueId]);

    const simulateLoaderModal = () => {
        setModalData({
            ...modalData,
            header: <>Simuler la réponse du Loader</>,
            content: <div>
                <strong>Version Loader : </strong>
                <input type="number" name="loaderVersionSent" id="loaderVersionSent" />
            </div>,
            validateButton: 'Valider',
            cancelButton: 'Annuler',
            onValidate: () => {
                let loaderVersionSent = document.getElementById('loaderVersionSent')?.value;
                const loaderRoute = ACTIONS?.['headsetApp']?.['loaderRoute']?.url?.replace('loaderVersion', loaderVersionSent);
                if (loaderRoute && loaderVersionSent && loaderVersionSent !== "") {
                    setIsSending(true);
                    setVersionSimulated(loaderVersionSent);
                    return axios.get(loaderRoute)
                        .then((result) => {
                            setLoaderApps(result);
                            return result;
                        })
                        .catch(error => {
                            return Promise.reject(error);
                        })
                        .finally(() => {
                            setIsSending(false);
                            setModalShow(false);
                        });
                }
            }
        });
        setModalShow(true);
    };

    const resetSimulation = () => {
        setLoaderApps(null);
        setVersionSimulated(null);
    }

    return (
        <Container fluid>
            {isFetchingOnePackage ? (
                <Loader />
            ) : (
                <>

                    <Row>
                            <h2 className="d-flex justify-content-between">
                                {packageById?.name}
                                {backButtonComponent}
                            </h2>
                    </Row>

                    {AuthorizationChecker.hasUpdateRights('packages') && packagesSlugs?.update &&
                        <Row className="mb-2">
                            <Col className="col-auto">
                                <Button variant="secondary" size="sm" as={Link} to={packagesSlugs.update.replace(':uniqueId', uniqueId)}><i className="fas fa-edit"/> Éditer</Button>
                            </Col>
                        </Row>
                    }

                    <PackageClientsComponent clients={packageById?.clients} isDefault={packageById?.isDefault} />

                    {/* Show table and controls only if APKs exist */}
                    {packageById?.apks?.length > 0 ? (
                        <>
                            <Row className="item-page mb-2">
                                <Col>{searchInput}</Col>
                                <Col className="col-auto">
                                    <Button variant="light" onClick={simulateLoaderModal}>
                                        Simuler le loader
                                    </Button>
                                </Col>
                                    {apkSlugs?.create
                                        && <Col className="col-auto">
                                            <Button variant="success" as={Link} to={`${apkSlugs.create}?packageUniqueId=${packageById?.uniqueId}`}><i className="fas fa-plus"></i> &nbsp;Nouveau</Button>
                                        </Col>}
                            </Row>

                            <ApkFiltersComponent
                                allApks={packageById.apks}
                                setFilteredApks={setFilteredApks}
                                search={search}
                                loaderApps={loaderApps}
                            />

                            {loaderApps && (
                                <Row className="d-flex justify-content-center m-4">
                                    <Col className="col-auto">
                                        <strong>Simulation Loader </strong>
                                        (Version Loader: {versionSimulated}){" "}
                                        <Button
                                            variant="danger"
                                            className="ml-4"
                                            onClick={resetSimulation}
                                        >
                                            Rétablir le tableau initial
                                        </Button>
                                    </Col>
                                </Row>
                            )}

                            {filteredApks?.length > 0 ? (
                                <ApksTableComponent apks={filteredApks} />
                            ) : (
                                <Alert variant="warning">
                                    Aucune application ne correspond à votre recherche
                                </Alert>
                            )}

                            {modalComponent}
                        </>
                    ) : (
                        <Alert variant="warning">Aucune application à afficher</Alert>
                    )}
                </>
            )}
        </Container>
    );

};

export default PackageDetailPage;
